import { render, staticRenderFns } from "./ProjectGroupsTable.vue?vue&type=template&id=590d8b82&scoped=true&lang=pug"
import script from "./ProjectGroupsTable.vue?vue&type=script&lang=js"
export * from "./ProjectGroupsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590d8b82",
  null
  
)

export default component.exports